import React from 'react';
import { shape, bool, string, func } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import { billPropTypes } from 'types/billTypes';
import UTCheckbox from 'app/components/UTCheckbox';

import styles from './styles';

export default class HeaderField extends React.Component {
  handleChange = () => this.props.onCheck && this.props.onCheck(this.props.row);

  render() {
    return (
      <div style={styles.container}>
        <UTCheckbox onChange={this.handleChange} value={this.props.row.checked} />
        {this.props.row.label && (
          <UTLabel small bold white>
            {this.props.row.label}
          </UTLabel>
        )}
      </div>
    );
  }
}

HeaderField.propTypes = {
  row: shape({
    value: shape(billPropTypes),
    checked: bool.isRequired,
    label: string
  }),
  onCheck: func.isRequired
};
